import Vue from "vue";
import BaseCard from "./containers/BaseCard.vue";
import BaseButton from "./BaseButton.vue";
import BaseTag from "./BaseTag.vue";
import BaseDialog from "./BaseDialog.vue";
import BaseDialogButton from "./BaseDialogButton.vue";
import BaseDialogConfirmButton from "./BaseDialogConfirmButton.vue";
import BaseForm from "./BaseForm.vue";
import BaseTable from "./BaseTable.vue";
import DefinitionField from "./DefinitionField.vue";
import ModuleLink from "./ModuleLink";
import ActionButton from "./ActionButton.vue";
import ResourceItemReference from "./resource/ResourceItemReference";
import {
  StringField,
  SelectField,
  LabeledOptionSelectField,
  DateField,
  ResourceItemField,
  IntegerField,
  BooleanField,
  DecimalField,
} from "./form/InputFields";
import {
  StringEntry,
  ItemRefEntry,
  BooleanEntry,
  TextEntry,
  UrlEntry,
  OptionLabelEntry,
  DateTimeEntry,
} from "./sheet/SheetEntries";

Vue.component("BaseCard", BaseCard);
Vue.component("BaseButton", BaseButton as any);
Vue.component("BaseTag", BaseTag as any);
Vue.component("BaseDialog", BaseDialog as any);
Vue.component("BaseDialogButton", BaseDialogButton as any);
Vue.component("BaseDialogConfirmButton", BaseDialogConfirmButton as any);
Vue.component("BaseForm", BaseForm as any);
Vue.component("BaseTable", BaseTable as any);

Vue.component("ModuleLink", ModuleLink as any);
Vue.component("DefinitionField", DefinitionField);
Vue.component("ActionButton", ActionButton as any);
Vue.component("ResourceItemReference", ResourceItemReference as any);

// Input fields
Vue.component("StringField", StringField);
Vue.component("ResourceItemField", ResourceItemField);
Vue.component("IntegerField", IntegerField);
Vue.component("DecimalField", DecimalField);
Vue.component("BooleanField", BooleanField);
Vue.component("SelectField", SelectField);
Vue.component("LabeledOptionSelectField", LabeledOptionSelectField);
Vue.component("DateField", DateField);

// Sheet entries
Vue.component("StringEntry", StringEntry);
Vue.component("ItemRefEntry", ItemRefEntry);
Vue.component("BooleanEntry", BooleanEntry);
Vue.component("TextEntry", TextEntry);
Vue.component("UrlEntry", UrlEntry);
Vue.component("OptionLabelEntry", OptionLabelEntry);
Vue.component("DateTimeEntry", DateTimeEntry);
